export default __webpack_public_path__ + "images/3c2bf9a39e4a7b9844ac5ef4c156ca48.svg";